export const dimensionsFromResolution = (height, resizable) => {
    const width = (height * 1280) / 720;
    return Object.assign({ height: height.toString(), width: width.toString() }, (resizable
        ? {
            width: '100%',
            paddingTop: '56.25%',
            height: 'auto'
        }
        : undefined));
};
//# sourceMappingURL=dimensionsFromResolution.js.map